import Collection from "../models/Collection.model"

// test: jest src/presenters/__tests__/DynamicFormValue.presenter.spec.js
export default class DynamicFormValuePresenter {
  static branch(dynamicFormField, branch) {
    return {
      branch_provider: dynamicFormField?.branch_provider,
      text: branch?.name,
      value: branch?.id,
    }
  }

  static collectionItem(dynamicFormField, collectionItem, collection) {
    const collectionModel = new Collection(collection)

    return {
      type: dynamicFormField?.type,
      collection_item_id: collectionItem?.id,
      collection_id: collection?.id,
      text: collectionModel.textForOption(collectionItem.id),
    }
  }
}
